const iconPaths = {
  inbox: 'M3 5h18v14H3V5Zm0 8h5l2 3h4l2-3h5M3 5l9 7 9-7',
  documents: 'M7 3h8l4 4v14H7V3Zm8 0v5h4M10 12h6m-6 4h6M4 7v14',
  calendar: 'M4 5h16v16H4V5Zm3-3v6m10-6v6M4 10h16M8 14h2m4 0h2m-8 3h2',
  inventory: 'm3 7 9-4 9 4v10l-9 4-9-4V7Zm0 0 9 4 9-4M12 11v10M7 5l10 4',
  finance: 'M5 3h14v18l-3-2-4 2-4-2-3 2V3Zm3 5h8m-8 4h8m-8 4h4',
  people: 'M16 21v-3a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v3M16 4a4 4 0 0 1 0 8m2 3a4 4 0 0 1 3 4v2M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  tasks: 'M9 5h12M9 12h12M9 19h12M3 5l1 1 2-3M3 12l1 1 2-3M3 19l1 1 2-3',
  portal: 'M3 4h18v16H3V4Zm0 5h18M6 6.5h1m3 0h1M9 13l-2 2 2 2m6-4 2 2-2 2',
  messages: 'M3 4h18v13H9l-6 4V4Zm4 5h10M7 13h6',
  truck: 'M3 5h11v12H3V5Zm11 5h4l3 4v3h-7M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
};

function iconFor(label: string): keyof typeof iconPaths {
  if (/inbox|email/i.test(label)) return 'inbox';
  if (/messag|whatsapp|correspondence/i.test(label)) return 'messages';
  if (/calendar|booking|schedul/i.test(label)) return 'calendar';
  if (/accounting|payment|payroll|purchas|estimating|expense|time tracking/i.test(label)) return 'finance';
  if (/carrier|transport|dispatch/i.test(label)) return 'truck';
  if (/inventory|stock|asset|batch|pos|erp/i.test(label)) return 'inventory';
  if (/crm|customer|student|applicant|practice|property records/i.test(label)) return 'people';
  if (/task|queue|project|approval|helpdesk|service desk|review|audit/i.test(label)) return 'tasks';
  if (/portal|store|product events|channels|system/i.test(label)) return 'portal';
  return 'documents';
}

export default function WorkflowSystems({ systems, iconSystems }: { systems: string; iconSystems: string }) {
  return <aside className="ws-systems" aria-label="ระบบที่จะเชื่อมต่อ">
    <h4>ระบบที่จะเชื่อมต่อ</h4>
    <ul>{systems.split(', ').map((label, index) => <li key={label}>
      <span className="ws-system-icon" aria-hidden="true">
        {/xero|whatsapp/i.test(label) ? <img src={`${import.meta.env.BASE_URL}logos/${/xero/i.test(label) ? 'xero' : 'whatsapp'}.svg`} alt="" width="24" height="24" /> :
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d={iconPaths[iconFor(iconSystems.split(', ')[index])]} /></svg>}
      </span><span>{label.charAt(0).toUpperCase() + label.slice(1)}</span>
    </li>)}</ul>
  </aside>;
}
